import * as React from 'react';
import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';
import { ContentContainer } from 'common/components/cookbook/ContentContainer';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';

import { Steps } from './Steps';
import { CloseButton } from '../components/CloseButton';

const Root = styled(ContentContainer)`
  flex-direction: column;
  padding-bottom: 12px;
  background: #20212566;
`;

const TitleRow = styled.div`
  display: flex;
  flex: 1px;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled(T.bodyLabel)`
  color: ${color.textInverse};
  user-select: none;
`;

const StepsRow = styled.div`
  margin-top: 12px;
`;

type Props = {
  title: string;
  currentStep: number;
  totalSteps: number;
  isPaused: boolean;
  progressBeforePause: number;
  onStepClick?: (step: number) => void;
  onClose: () => void;
};

export const Header: React.FC<Props> = ({
  title,
  currentStep,
  totalSteps,
  isPaused,
  progressBeforePause,
  onStepClick,
  onClose,
}) => {
  return (
    <Root>
      <TitleRow>
        <div>
          <Title>{title}</Title>
        </div>
        <div>
          <CloseButton onClick={onClose} />
        </div>
      </TitleRow>

      <StepsRow>
        {!!totalSteps && onStepClick && (
          <Steps
            currentStep={currentStep}
            totalSteps={totalSteps}
            isPaused={isPaused}
            progressBeforePause={progressBeforePause}
            onStepClick={onStepClick}
          />
        )}
      </StepsRow>
    </Root>
  );
};
